import { Component } from "@angular/core";

@Component({
  selector: "app-google-disconnect-dialog",
  templateUrl: "./google-disconnect-dialog.component.html",
  styleUrls: ["../third-party-disconnect-dialog.component.scss"],
})
export class GoogleDisconnectDialogComponent {}
